import { findArray } from "helpers/utils"
import Label from "components/general/Label"
import { RscFromStore } from "helpers/utils"
import { getRscObject } from "helpers/rsc"
import SportCode from "components/common/SportCode"
import { ColumnRank, ColumnBib, ColumnName, ColumnWarnings, ColumnNoc, ColumnPoints, ColumnRecords, ColumnQualification, ColumnExpander } from "components/common/TableColumns"
import { CellTieRule } from "../../race_track_sb/result/CellTieRule"


function getCell(row) {
    let cell = null

    if (!!row) {

        let wind = findArray(row.extendedResults, { er_code: ['WIND_SPEED'], er_type: ['ER'] })?.er_value
        let value = row?.resultData
        cell = <><div>{value}</div> <div className="fst-italic">{wind}</div></>
    }
    return cell

}


export function ColumnResult({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderResult'
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'SortOrder',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: 'Result',

            Cell: (props) => {
                let rsc = RscFromStore()
                let discipline = getRscObject(rsc).discipline
                let rowNumberIrm = findArray(props.cell.row.original.extendedResults, { er_code: ['IRM_LAP'] })
                let numberIrm = rowNumberIrm?.er_value || ''
                let resultIrm = (props.cell.row.original.resultIrm)

                let irmObject = {}
                switch (resultIrm) {
                    case 'DNF':
                        irmObject = <><SportCode discipline={discipline} entity='@IRM' code={resultIrm} abbr={true} />{numberIrm}</>
                        break;
                    case 'LAP':
                        irmObject = <>{numberIrm}<SportCode discipline={discipline} entity='@IRM' code={resultIrm} abbr={true} /></>
                        break;
                    default:
                        irmObject = <SportCode discipline={discipline} entity='@IRM' code={resultIrm} abbr={true} />
                        break;
                }

                return (
                    props.cell.row.original.resultType === 'IRM'
                        ? irmObject
                        : getCell(props.cell.row.original)
                )
            },
        }
    )
}




export function TableColumns(columnsAdded) {
    return (
        [
            ColumnRank({}),
            ColumnBib({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnWarnings({}),
            ColumnResult({}),
            {
                accessor: 'extendedResults',
                id: 'TieRules',
                className: '',
                headerClassName: 'w-5',
                Cell: (props) => (
                    props.cell.row.original.extendedResults
                        ? <CellTieRule extendedResults={props.cell.row.original.extendedResults}></CellTieRule>
                        : ''
                )
            },
            ColumnRecords({}),
            ColumnQualification({}),
            ColumnExpander({ type: 'extendedResults', expandIrm: true })

        ]
    )
}

export default TableColumns
